// extracted by mini-css-extract-plugin
export default {"select":"SpecificDaySelector_select__cp2cn","error":"SpecificDaySelector_error__LaWMj"};